// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"kX-z","sponsoredTooltipWrapper":"lX-z","sponsoredTooltip":"mX-z","newCard":"nX-z"};